import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {
    IEmptySeed,
    ISeedProduct,
    ISeedCategory,
    ISeedProductSubmit,
    ISeedAttributeValue,
} from '../../../infrastructure/interfaces';
import SeedForm from '../../Products/SeedForm';
import PreviewSeedProductModal from '../../Modals/PreviewSeedProductModal/PreviewSeedProductModal';
import { FilterMenu } from '../../FilterMenu';
import { saveSeedProduct } from "../../../actions/actions";

export interface ISeedsTableProps {
  seedList: ISeedProduct[]; //comes from redux
  seedCategories: ISeedCategory[];
  saveSeedProduct(seed: ISeedProductSubmit, isTogglingPublish: Boolean): void;
}

export interface ISeedsTableState {
    showEditModal: boolean;
    showPreviewModal: boolean;
    editingProduct: ISeedProduct | IEmptySeed | undefined;
    previewingProduct: ISeedProduct | null;
    seedsFilter: string;
    categoryFilter: string;
    publishedFilter: boolean | undefined;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        saveSeedProduct: (seed: ISeedProductSubmit, isTogglingPublish: Boolean) => {
            dispatch(saveSeedProduct(seed, isTogglingPublish));
        },
    };
};

const mapStateToProps = (state: any) => {
  return {
      seedList: state.seedList,
      seedCategories: state.wizard.seedCategories,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class SeedsTable extends React.Component<
  ISeedsTableProps,
  ISeedsTableState
> {
  shouldUpdate = false;
  tableRow: HTMLElement;
  constructor(props: ISeedsTableProps) {
    super(props);

    this.state = {
      showEditModal: false,
      showPreviewModal: false,
      editingProduct: undefined,
      previewingProduct: null,
      seedsFilter: '',
      categoryFilter: '',
      publishedFilter: undefined,
    };
  }

  componentWillReceiveProps(nextProps: any) {
    this.shouldUpdate = true;
  }

  onEditProduct = (product: ISeedProduct) => {
    this.shouldUpdate = true;
    this.setState({
      editingProduct: product,
      showEditModal: true,
    });
  };

  onCloneProduct = (product: ISeedProduct) => {
    this.shouldUpdate = true;
    let clonedProduct: IEmptySeed = {
        id: undefined,
        name: "COPY: " + product.name,
        published: false,
        isNew: product.isNew,
        brand: product.brand,
        category: product.category,
        bulletPointMarkdown: product.bulletPointMarkdown,
        attributes: product.attributes,
        icons: product.icons,
        type: product.type,
    }
    this.setState({
      editingProduct: clonedProduct,
      showEditModal: true,
    });
  };

  onPublishToggle = (product: ISeedProduct) => {
    this.shouldUpdate = true;
    product.published = !product.published;
    
    //maps to submit shape
    const fromRead = (dto: ISeedProduct) => {
      const result: ISeedProductSubmit = {
        ...dto,
        categoryId: dto.category.id,

        //attributes: [{ attributeId: 1, value: "9" }],
        attributes: dto.attributes.map((a: ISeedAttributeValue) => {
          return { attributeId: a.attribute.id, value: a.value };
        }),
      };
      return result;
    };

    const toSubmit = fromRead(product);
    this.props.saveSeedProduct(toSubmit, true);
  };

  onPreviewProduct = (product: ISeedProduct) => {
    this.shouldUpdate = true;
    this.setState({
      previewingProduct: product,
      showPreviewModal: true,
    });
  };

  filterProducts = (products: any[]) => {
    const seedsFilter = this.state.seedsFilter.toUpperCase();
    const seedsFilteredProducts = products.filter((p) =>
      seedsFilter ? (p.name.toUpperCase().indexOf(seedsFilter) > -1) : true
    );
    const filteredProducts = seedsFilteredProducts.filter((p) => {
        const includedInCategoryFilter = ((this.state.categoryFilter.length == 0) || (this.state.categoryFilter == (p.category && p.category.name)));
        const includedInPublishFilter = ((this.state.publishedFilter == undefined) || (this.state.publishedFilter == p.published));
        return includedInCategoryFilter && includedInPublishFilter;
        }
    );

    return filteredProducts;
  };

  onSearchFilterChange = (e: any) => {
    this.setState({
      seedsFilter: e.target.value,
    });
    // keyCode === 8 is a 'backspace' event
    e.keyCode === 8 && !e.target.value
      ? (this.shouldUpdate = true)
      : (this.shouldUpdate = false);
  };

  render() {
    const { seedList } = this.props;
    const filteredProducts = this.filterProducts(seedList);

    const { showEditModal, showPreviewModal } = this.state;

    if (showEditModal) {
      return (
        <SeedForm 
            seed={this.state.editingProduct}
            show={this.state.showEditModal}
            onClose={() => this.setState({showEditModal: false})}
        />

      );
    }

    if (showPreviewModal && this.state.previewingProduct) {
      return (
        <PreviewSeedProductModal
          show={this.state.showPreviewModal}
          product={this.state.previewingProduct}
          onClose={() => this.setState({ showPreviewModal: false })}
        />
      );
    }
    return (
      <div className="inner-su-container">
        <div className="manage-items-row">
          <div className="productTable-search">
            <input
              type="text"
              onKeyUp={this.onSearchFilterChange}
              placeholder="Search Products"
            />
          </div>

          <div className="in-row-text-container-products">Manage Seeds</div>

          <div className="in-row-button-container">
              <button
                className="btn primary-green large"
                onClick={() => this.setState({ 
                    editingProduct: undefined,
                    showEditModal: true,
                    })}
                title={TooltipCont.CREATE_PRODUCT}
              >
                Create New Seed
              </button>

          </div>
        </div>
        <table className="table-scrollableSU documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th>Seed</th>
              <th>
                <FilterMenu
                  title="Category"
                  options={this.props.seedCategories.map((p) => {
                    return { title: p.name };
                  })}
                  onFilter={(filterApplied: string) => {
                      this.shouldUpdate = true;
                      this.setState({ categoryFilter: filterApplied });
                  }}
                />
              </th>
              <th>
                <FilterMenu
                  title="Published/Unpublished"
                  options={[{ title: 'Published' }, { title: 'Unpublished' }]}
                  onFilter={(filterApplied: string) => {
                    this.shouldUpdate = true;
                    var publishedFilter: boolean | undefined = undefined;
                    if (filterApplied == 'Published') {
                        publishedFilter = true;
                    } else if (filterApplied == 'Unpublished') {
                        publishedFilter = false
                    }
                    this.setState({ publishedFilter });
                  }}
                />
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {filteredProducts.map((p: ISeedProduct, index, array) => (
              <tr
                key={p.id + '_' + p.category.id}
                ref={(tr) => (this.tableRow = tr!)}
              >
                <td dangerouslySetInnerHTML={{ __html: p.name }} />
                <td>{(p.category && p.category.name) || 'Unknown'}</td>
                <td>{p.published ? 'Published' : 'Unpublished'}</td>
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onEditProduct(p)}
                      title={TooltipCont.EDIT}
                      disabled={false}
                    >
                      Edit
                    </button>

                    <button
                      className="btn primary-blue"
                      onClick={() => this.onPublishToggle(p)}
                      title={TooltipCont.PUBLISH}
                      disabled={false}
                    >
                      {p.published ? 'Unpublish' : 'Publish'}
                    </button>
                  </div>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onPreviewProduct(p)}
                      title={TooltipCont.PREVIEW}
                      disabled={false}
                    >
                      Preview
                    </button>

                    <button
                      className="btn primary-blue"
                      onClick={() => this.onCloneProduct(p)}
                      title={TooltipCont.CLONE}
                      disabled={false}
                    >
                      Clone
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/SeedsTable.tsx